import React, { useRef, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styles from './Css/SliderPanel.module.css';
import SexyButton from './../Buttons/SexyButton';
import { useTranslation } from 'react-i18next';
import fireGif from './../../Assets/Gif/fire.gif';

const SliderPanel = ({ TGMainButtonColor, colorThemeButton, pages, currentPage, setCurrentPage, isVisible, setViewType }) => {
    const countRef = useRef(null);
    const { t } = useTranslation();
    const [isOnFire, setIsOnFire] = useState(false);
    const isDarkTheme = window.Telegram?.WebApp?.colorScheme === 'dark';

    const handleClick = (button) => {
        setCurrentPage(button);
        setViewType(button === 'account' ? '' : button);
    };

    const BasketList = useSelector(state => state.shop.basket);
    const ShopSettings = useSelector(state => state.shop.shop.settings);
    const countItems = BasketList.reduce((total, item) => total + Number(item.count), 0);

    useEffect(() => {
        if (countItems > 0 && ShopSettings.show_fire_basket) {
            setIsOnFire(true);
            const timer = setTimeout(() => {
                setIsOnFire(false);
            }, 1000);

            return () => clearTimeout(timer);
        }
    }, [countItems]);

    return (
        <div className={`${styles.bottomPanel} storefront-bottom-panel ${isDarkTheme ? styles.bottomPanelDark : ''}`} style={{
            // marginBottom: isVisible ? '0' : `-250px`,
            // transition: "1s all"
        }}>
            <div className={styles.bottomPanelContent}>
                <SexyButton
                    key={'shop'}
                    className={`${styles.bottomPanelButton} storefront-bottom-button`}
                    onClick={() => handleClick('shop')}
                    aria-pressed={currentPage === 'shop'}
                    style={{height: 40}}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
                        <path fill={currentPage === 'shop' ? (TGMainButtonColor) : "var(--tg-theme-text-color)"}
                              d="m19.463 8.858-.002-.002L11.302.54A1.829 1.829 0 0 0 10 0a1.83 1.83 0 0 0-1.302.54L.543 8.851l-.008.008a1.843 1.843 0 0 0 .003 2.6 1.83 1.83 0 0 0 1.279.54h.325v5.845c0 1.188.967 2.155 2.155 2.155H7.49a.586.586 0 0 0 .586-.586v-4.707c0-.542.442-.983.984-.983h1.883c.542 0 .983.44.983.983v4.707c0 .324.262.586.586.586h3.192a2.157 2.157 0 0 0 2.155-2.155V12h.302a1.83 1.83 0 0 0 1.302-.54 1.844 1.844 0 0 0 0-2.602Z"/>
                    </svg>
                    <span className="storefront-bottom-label">{t('mainCategory')}</span>
                </SexyButton>
                <SexyButton
                    key={'basket'}
                    className={`${styles.bottomPanelButton} storefront-bottom-button`}
                    onClick={() => handleClick('basket')}
                    aria-pressed={currentPage === 'basket'}
                    style={{ height: 40 }}
                >
                    {isOnFire ? (
                        <img src={fireGif} alt="fire" className={styles.fireAnimation} style={{ width: 26, height: 24 }} />
                    ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" fill="none">
                            <path fill={currentPage === 'basket' ? (TGMainButtonColor) : "var(--tg-theme-text-color)"}
                                  fillRule="evenodd"
                                  d="M9.522 14.866a1 1 0 0 0 1.1.653l12.766-2.036a1 1 0 0 0 .823-.792l1.355-6.792a1 1 0 0 0-.964-1.196l-17.36-.28a1 1 0 0 0-.958 1.335l3.238 9.108ZM10.326 23.052a2.326 2.326 0 1 0 0-4.652 2.326 2.326 0 0 0 0 4.652ZM21.957 23.052a2.326 2.326 0 1 0 0-4.652 2.326 2.326 0 0 0 0 4.652Z"
                                  clipRule="evenodd"/>
                            <path fill={currentPage === 'basket' ? (TGMainButtonColor ) : "var(--tg-theme-text-color)"}
                                  d="M6.169.9h-4.71a1.31 1.31 0 1 0 0 2.618h3.337a1 1 0 0 1 .945.672l.942 2.71L9.35 5.6 8.035 2.182A2 2 0 0 0 6.17.9Z"/>
                        </svg>
                    )}
                    <span className="storefront-bottom-label">{t('basket')}</span>
                    {
                        countItems > 0 && (
                            <div ref={countRef} className={`${styles.countBasketNotification} mainButton`}>
                                {countItems}
                            </div>
                        )
                    }
                </SexyButton>
                {
                    ShopSettings.show_catalogs_menu === 1 && (
                        <SexyButton
                            key={'catalog'}
                            className={`${styles.bottomPanelButton} storefront-bottom-button`}
                            onClick={() => handleClick('catalog')}
                            aria-pressed={currentPage === 'catalog'}
                            style={{height: 40}}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23"
                                 fill={currentPage === 'catalog' ? (TGMainButtonColor ) : "var(--tg-theme-text-color)"}
                                 className="bi bi-grid-fill" viewBox="0 0 16 16">
                                <path
                                    d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5zm8 0A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5zm-8 8A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5zm8 0A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5z"/>
                            </svg>
                            <span className="storefront-bottom-label">{t('storefront_nav_catalog')}</span>
                        </SexyButton>
                    )
                }
                <SexyButton
                    key={'info'}
                    className={`${styles.bottomPanelButton} storefront-bottom-button`}
                    onClick={() => handleClick('info')}
                    aria-pressed={currentPage === 'info'}
                    style={{height: 40}}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23"
                         fill={currentPage === 'info' ? (TGMainButtonColor) : "var(--tg-theme-text-color)"}
                         className="bi bi-info-circle-fill" viewBox="0 0 16 16">
                        <path
                            d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/>
                    </svg>
                    <span className="storefront-bottom-label">{t('storefront_nav_info')}</span>
                </SexyButton>
                <SexyButton
                    key={'account'}
                    className={`${styles.bottomPanelButton} storefront-bottom-button`}
                    onClick={() => handleClick('account')}
                    aria-pressed={currentPage === 'account'}
                    style={{height: 40}}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="22" fill="none">
                    <path fill={currentPage === 'account' ? (TGMainButtonColor ) : "var(--tg-theme-text-color)"}
                              d="M12.25 10.1c2.476 0 4.6-2.124 4.6-4.864C16.85 2.531 14.714.5 12.25.5c-2.464 0-4.612 2.078-4.6 4.76 0 2.716 2.124 4.84 4.6 4.84ZM12.25 12.3c-5.82 0-9.192 3.497-10.569 6.515-.687 1.507.612 2.885 2.268 2.885H20.55c1.657 0 2.955-1.379 2.268-2.886-1.378-3.018-4.75-6.514-10.569-6.514Z"/>
                    </svg>
                    <span className="storefront-bottom-label">{t('account')}</span>
                </SexyButton>
            </div>
        </div>
    );
};

export default SliderPanel;
